import React from 'react';
import { Row,Col } from 'reactstrap';
import CardFeature from './CardFeature';

export default class Services extends React.Component{
    render(){
        return (
            <div className="container padding-vert">
                <Row>
                    <Col>
                        <h4>Services Offered</h4>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CardFeature img="f1.png" title="Giga Fiber Internet Connection"/>
                    </Col>
                    <Col>
                        <CardFeature img="f2.jpg" title="Leased Line Internet Connection"/>
                    </Col>
                    <Col>
                        <CardFeature img="f3.png" title="Static IP Providing" />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <CardFeature img="f4.png" title="Hotel Wifi Solution"/>
                    </Col>
                    <Col>
                        <CardFeature img="f5.jpg" title="CCTV Camera Installation"/>
                    </Col>
                    <Col>
                        <CardFeature img="f7.png" title="Television Cable Services" />
                    </Col>
                </Row>
            </div>
        )
    }
}